import axios from '@/allotment/axios'

export default {
  list: () => axios.get('/parse/dp/list'), //查询待解析dp点集合
  post: (dpId, dpValue) => axios.post('/parse/dp/value', { dpId, dpValue }) //解析dp值
}
